import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["inline", "required", "disabled", "error", "success", "children"];
import React, { useMemo, forwardRef } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import ScopedCssBaseline from '../StyleBase/ScopedCssBaseline';
import Context from './FormControlContext';
const Root = styled.div.withConfig({
  displayName: "FormControl__Root",
  componentId: "sc-q68k3f-0"
})(["", " border:none;padding:0;margin:0 0 var(--size-spacing-04) 0;", ""], ScopedCssBaseline, _ref => {
  let {
    inline
  } = _ref;
  return inline && css(["display:inline-flex;align-items:center;margin-bottom:0;margin-right:var(--size-spacing-04);"]);
});
const FormControl = /*#__PURE__*/forwardRef((_ref2, ref) => {
  let {
    inline,
    required,
    disabled,
    error,
    success,
    children
  } = _ref2,
      rest = _objectWithoutPropertiesLoose(_ref2, _excluded);

  const context = useMemo(() => ({
    inline,
    required,
    disabled,
    error,
    success
  }), [inline, required, disabled, error, success]);
  return /*#__PURE__*/React.createElement(Context.Provider, {
    value: context
  }, /*#__PURE__*/React.createElement(Root, _extends({
    ref: ref
  }, rest, {
    inline: inline
  }), children));
});
FormControl.Context = Context;
FormControl.displayName = 'FormControl';
FormControl.defaultProps = {
  children: null,
  disabled: false,
  error: false,
  success: false,
  required: false,
  inline: false
};
process.env.NODE_ENV !== "production" ? FormControl.propTypes = {
  /**
   * Sets the children.
   */
  children: PropTypes.node.isRequired,

  /**
   * Sets the input, label and helper text with disabled state.
   */
  disabled: PropTypes.bool,

  /**
   * Sets the input, label and helper text with error state.
   */
  error: PropTypes.bool,

  /**
   * Sets the label and input inline position.
   */
  inline: PropTypes.bool,

  /**
   * Sets the input, label and helper text with success state.
   */
  success: PropTypes.bool,

  /**
   * Sets the input as required.
   */
  required: PropTypes.bool
} : void 0;
export default FormControl;